<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.member')"
    namespace=""
    resource="members"
    :actionColumnProps="{ width: 80 }"
    :exportProps="{
      buttonText: this.$t('export'),
      url: '/members/export' ,
    }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { MEMBER_USER_TYPES } from '@/constants';
import _ from 'lodash';

@Component
export default class Members extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'email_cont',
        label: this.$t('member.email'),
        renderCell: {
          component: 'input'
        },
      },
      {
        prop: 'name_cont',
        label: this.$t('member.name'),
        renderCell: {
          component: 'input'
        },
      },
      {
        prop: 'user_type_eq',
        label: this.$t('member.userType'),
        renderCell: {
          component: 'select',
          props: {
            options: _.map(MEMBER_USER_TYPES, (value) => ({ value, label: this.$t(`member.userTypes.${value}`) })),
            clearable: true
          }
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'name',
        label: this.$t('member.name'),
      },
      {
        prop: 'email',
        label: this.$t('member.email'),
      },
      type === 'show' && {
        prop: 'gender',
        label: this.$t('member.gender'),
        renderCell: (h, { props: { value } }) => {
          return <span>{value && this.$t(`member.genders.${value}`)}</span>
        }
      },
      {
        prop: 'user_type',
        label: this.$t('member.userType'),
        renderCell: (h, { props: { value } }) => {
          return <span>{value && this.$t(`member.userTypes.${value}`)}</span>
        }
      },
      {
        prop: 'user',
        label: this.$t('member.user'),
        renderCell: (h, { props: { value } }) => {
          return <bean-link keepNode to={{ name: 'users.show', params: { id: value.id } }}>{_.get(value, 'screen_name', value.id)}</bean-link>
        }
      },
      type === 'show'  && {
        prop: 'wechat',
        label: this.$t('member.wechat'),
      },
      type === 'show'  && {
        prop: 'birth_year',
        label: this.$t('member.birthYear'),
      },
      type === 'show' && {
        prop: 'province',
        label: this.$t('member.province'),
        renderCell: (h, { props: { scope: { row } } }) => {
          return <span>{_.get(row, 'province.name', '/')}</span>
        }
      },
      type === 'show' && {
        prop: 'city',
        label: this.$t('member.city'),
        renderCell: (h, { props: { scope: { row } } }) => {
          return <span>{_.get(row, 'city.name', '/')}</span>
        }
      },
      type === 'show'  && {
        prop: 'questionaire',
        label: this.$t('member.questionaire'),
        renderCell: (h, { props: { value } }) => {
          console.log(value)
          return (<div>
            {
              _.map(value, (v, i) => {
                return (<div>
                  <div>{i + 1}. {v.question}</div>
                  <div>{
                    _.map(v.options, o => {
                      return <div>{o}</div>
                    })
                  }</div>
                </div>)
              })
            }
          </div>)
        }
      },
      type === 'show' && {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      type === 'show' && {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions() {
    return [];
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/members',
    name: 'members.index',
    component: Members,
    props: {
      type: 'index',
    }
  },
  {
    path: '/members/:id',
    name: 'members.show',
    component: Members,
    props: {
      type: 'show',
    }
  },
]
</script>
